module.exports = __webpack_public_path__ + "static/media/EricJanKaak.8e714383.jpg";